// extracted by mini-css-extract-plugin
export default {"productGrid":"g0-z","centerLink":"h0-z","productSection":"i0-z","item":"j0-z","ctaButton":"k0-z"};